<template>
  <div>
    <a-drawer title="推广专员团队详情" placement="right" :visible="visible" width="1200" @close="onClose">
      <!-- 条件搜索 -->
      <!-- <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="昵称" prop="name">
                <a-input v-model="queryParam.name" @pressEnter="handleQuery" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="ID" prop="id">
                <a-input v-model="queryParam.id" @pressEnter="handleQuery" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="注册时间" prop="createTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createTime"
                               :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>


            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />搜索</a-button>
                
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div> -->
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false">


        <span slot="totalOrders" slot-scope="text, record">
          <span v-if="record.totalOrders">{{record.totalOrders}}</span>
          <span v-else>0</span>
        </span>

        <span slot="totalWithdrawn" slot-scope="text, record">
          <span v-if="record.totalWithdrawn">{{ record.totalWithdrawn }}</span>
          <span v-else>0.00</span>
        </span>

        <span slot="sumKickback" slot-scope="text, record">
          <span v-if="record.sumKickback">{{ record.sumKickback }}</span>
          <span v-else>0.00</span>
        </span>

        <span slot="pendingWithdraw" slot-scope="text, record">
          <span v-if="record.pendingWithdraw">{{ record.pendingWithdraw }}</span>
          <span v-else>0.00</span>
        </span>
        

        <span slot="availableWithdraw" slot-scope="text, record">
          <span v-if="record.availableWithdraw">{{ record.availableWithdraw }}</span>
          <span v-else>0.00</span>
        </span>

        


        <span slot="operation" slot-scope="text, record">
          <a @click="getDetail(record)"> 提现明细 </a>
        </span>
      </a-table>

      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="visible = false"> 取消 </a-button>
        <a-button type="primary" @click="visible = false"> 确定 </a-button>
      </div>

      <detatilsView ref="detatilsRef"></detatilsView>
    </a-drawer>
  </div>
</template>

<script>
import moment from 'moment'
import detatilsView from './details.vue'
import { promotionManagerDetail } from '@/api/promotion/index'
export default {
  components: { detatilsView }, 

  data() {
    return {
      // 查询参数
      queryParam: {
        name: null,
        id: null,
        createTime: null
      },
      advanced: false,
      loading: false,
      visible: false,
      list: [],
      columns: [
        {
          title: '层级',
          dataIndex: 'level',
          align: 'center'
        },
        {
          title: '昵称',
          dataIndex: 'nickName',
          align: 'center'
        },
        {
          title: 'ID',
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          align: 'center'
        },
        {
          title: '注册时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '是否推广专员',
          dataIndex: 'isPromoterStr',
          align: 'center'
        },
        {
          title: '累计单量',
          dataIndex: 'totalOrders',
          scopedSlots: { customRender: 'totalOrders' },
          align: 'center'
        },
        {
          title: '累计佣金',
          dataIndex: 'sumKickback',
          scopedSlots: { customRender: 'sumKickback' },
          align: 'center'
        },

        {
          title: '累计提现',
          dataIndex: 'totalWithdrawn',
          scopedSlots: { customRender: 'totalWithdrawn' },
          align: 'center'
        },

        {
          title: '待结算',
          dataIndex: 'pendingWithdraw',
          scopedSlots: { customRender: 'pendingWithdraw' },
          align: 'center'
        },

        {
          title: '可提现',
          dataIndex: 'availableWithdraw',
          scopedSlots: { customRender: 'availableWithdraw' },
          align: 'center'
        },

        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  methods: {
    moment,
    getDetail(record) {
      this.$refs.detatilsRef.open(record)
    },
    open(row) {
      console.log(row)
      this.visible = true
      console.log('=====' + row.id)
      const par = { id: row.id }
      promotionManagerDetail(par).then((response) => {
        this.list = response.data
        // this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    // handleQuery () {
    //   this.getList()
    // },
    onClose() {
      this.visible = false
    }
  }
}
</script>
